import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import sad from '../../../images/other-images/sad.png';
import { BACK_TO_HOME_PAGE } from '../../constant';

const Error403 = ({ t }) => (
  <>
    <div className="page-wrapper">
      {/* <!-- error-403 start--> */}
      <div className="error-wrapper">
        <div className="container">
          <img className="img-100" src={sad} alt="" />
          <div className="error-heading">
            <h2 className="headline font-success">403</h2>
          </div>
          <div className="col-md-8 offset-md-2">
            <p className="sub-content">{t('global.error403')}</p>
          </div>
          <div><Link to="/app/dashboard" className="btn btn-success-gradien">{t('global.BACK_TO_HOME_PAGE')}</Link></div>
        </div>
      </div>
      {/* <!-- error-403 end--> */}
    </div>
  </>
);

export default translate(Error403);
